import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTwilioToken } from "../../services/twilioService";
import { initializeTwilioClient } from "../../services/twilioClient";

// Fetch Twilio token (serializable)
export const fetchTwilioTokenThunk = createAsyncThunk(
  "twilio/fetchToken",
  async (coachFriendlyName, { rejectWithValue }) => {
    try {
      return await fetchTwilioToken(coachFriendlyName);
    } catch (error) {
      return rejectWithValue(error.message || "Error fetching Twilio token");
    }
  }
);

export const initializeTwilioClientThunk = createAsyncThunk(
  "twilio/initClient",
  async ({ token, coachFriendlyName }, { rejectWithValue }) => {
    try {
      const client = await initializeTwilioClient(token, coachFriendlyName);
      return { connectionState: client.connectionState };
    } catch (error) {
      return rejectWithValue(
        error.message || "Error initializing Twilio Client"
      );
    }
  }
);

// Twilio Redux slice
const twilioSlice = createSlice({
  name: "twilio",
  initialState: {
    token: null,
    clientInitialized: false,
    connectionState: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTwilioTokenThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTwilioTokenThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.payload;
      })
      .addCase(fetchTwilioTokenThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(initializeTwilioClientThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(initializeTwilioClientThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientInitialized = true;
        state.connectionState = action.payload.connectionState;
      })
      .addCase(initializeTwilioClientThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const twilioReducer = twilioSlice.reducer;
